import { WarningIcon } from 'assets/icons';
import { FC, useState } from 'react';
import BlockedInfoPopup from './BlockedInfoPopup';
import { selectCurrentTeam } from 'containers/app/appSlice';
import { useAppSelector } from 'hooks';

const BlockerBanner: FC = () => {
  const [openBlockedInfoPopup, setOpenBlockedInfoPopup] = useState(false);
  const currentTeam = useAppSelector(selectCurrentTeam);
  const isTeamBlocked = currentTeam?.isTeamBlocked;
  const isMerchantBlocked = currentTeam?.isMerchantBlockedInTeam;

  const onMoreInfoClick = () => {
    setOpenBlockedInfoPopup(true);
  };

  return (
    <div className="flex items-center justify-between gap-2 bg-[#D95945] px-2.5 py-1">
      <div className="flex items-center gap-2">
        <WarningIcon className="shrink-0" />
        <div className="text-sbase font-semibold text-primary">
          Your {isTeamBlocked && !isMerchantBlocked ? 'team' : 'account'} is temporarily on hold.
        </div>
      </div>
      <div
        className="cursor-pointer text-sbase font-semibold text-primary underline"
        role="button"
        onClick={onMoreInfoClick}>
        More info
      </div>
      <BlockedInfoPopup isOpen={openBlockedInfoPopup} onClose={() => setOpenBlockedInfoPopup(false)} />
    </div>
  );
};

export default BlockerBanner;
